module.exports = __webpack_public_path__ + "static/img/0775.7581e88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0775.jpg
// module id = 113
// module chunks = 0